import { FC, ReactElement } from "react";
import { CircularProgress } from "./CircularProgress/CircularProgress";
import { AudioProgress } from "./AudioProgress.tsx/AudioProgress";
import { LineProgress } from "./LineProgress/LineProgress";
import { StepFromProgress } from "./StepFromProgress/StepFromProgress";
import { StepProgress } from "./StepProgress/StepProgress";

export const getPercentValue = ({count, value }: InnerProps) => {
  return Math.round((value / count) * 100);
};

const progressTypesComponent: {
  [key: number]: (props: InnerProps) => ReactElement;
} = {
  1: (props) => <LineProgress value={getPercentValue(props)} />,
  2: (props) => <AudioProgress value={getPercentValue(props)} />,
  3: (props) => <CircularProgress value={getPercentValue(props)} />,
  4: (props) => <StepFromProgress {...props} />,
  5: (props) => <StepProgress {...props} />,
};

type InnerProps = {
  count: number;
  value: number;
};

type Props = InnerProps & {
  progressType: number | null;
};

export const Progress: FC<Props> = ({ progressType, count, value }) => {
  if (!progressType) return <div></div>;
  return progressTypesComponent[progressType]({ count, value });
};
